import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_INSTANCE, buildURLWithState, fullBuildURL } from 'src/features/utils';
import type { Account } from 'src/types/types';
import { EventResponse } from 'src/types/types';

export const fetchAccountApi = async () => {
  return await API_INSTANCE.get<Account>(fullBuildURL(`/api/v1/dashboard/accounts`));
};

export const logoutApi = async () => {
  return await API_INSTANCE.get(`/auth/logout`);
};

export const fetchConnectedAccountsApi = async (state) =>
  await API_INSTANCE.get<Array<unknown>>(buildURLWithState(state, `/api/v1/connected-accounts`));

export const startFreeTrialApi = createAsyncThunk('account/free_trial', async (_, { getState }) => {
  return API_INSTANCE.post<EventResponse>(
    buildURLWithState(getState(), `/api/v1/dashboard/accounts/free_trial`),
  )
    .then((response) => response.data)
    .catch((error) => error);
});
export const updateAccountApi = async (data) => {
  return API_INSTANCE.put<any>(`/api/v1/dashboard/accounts`, data)
    .then((response) => response.data)
    .catch((error) => error);
};

export const updateSelectedSiteApi = async (siteId: string) => {
  return API_INSTANCE.put<Account>(fullBuildURL(`/api/v1/dashboard/accounts`), {
    selected_site_id: siteId,
  });
};
